import React from 'react'
import { Button, Layout, Menu, Breadcrumb, Icon, notification } from 'antd'
import { BrowserRouter as Router, Route, Link, Switch } from 'react-router-dom'
//import logo from '../logo.svg'
import Home from './Home'
import Random from './Random'
import About from './About'
import AboutPage from './AboutPage'
import Privacy from './Privacy'
import Terms from './Terms'
import Nav from './Nav'
//import Navbar from './Navbar'
import data from './data.js'
import AdSense from 'react-adsense'

const COOKIE = 'cookie'

const findNav=(list,slug)=>{
  if (Array.isArray(list)&&list.length>0) {
    for (let i in list) {
      const e = list[i]
      if (typeof(e)==='object'&&e!==null) {
        if (e.slug===slug) {
          return e
        }
      }
      const children = e.list
      if (Array.isArray(children)&&children.length>0) {
        const child = findNav(children,slug)
        if (typeof(child)==='object'&&child!==null) {
          return child
        }
      }
    }
  }
  return undefined
}

const BreadcrumbEntry=props=>{
  const {match} = props
  const {params} = match
  const {slug} = params

  const {navs} = data
  const home = navs[0]

  if (typeof(slug)==='string'&&slug.length>0) {
    const nav = findNav(navs,slug)
    if (typeof(nav)==='object'&&nav!==null) {
      return (
        <Breadcrumb>
          <Breadcrumb.Item><Nav {...home}/></Breadcrumb.Item>
          <Breadcrumb.Item><Nav {...nav} /></Breadcrumb.Item>
        </Breadcrumb>
      )
    }
  }
  return (
    <Breadcrumb>
      <Breadcrumb.Item><Nav {...home}/></Breadcrumb.Item>
    </Breadcrumb>
  )
}

export default class Main extends React.Component {
  state={}
  componentDidMount() {
    // show cookies notification on startup for the first time
    if (!localStorage.getItem(COOKIE)) {
      this.openNotification()
    }
  }
  onCloseNotification=()=>{
    localStorage.setItem(COOKIE, true)
  }
  openNotification=()=>{
    const style = {
      width: '100%',
    }
    const key = `notification-${Date.now()}`;
    const btn = (
      <Button type="primary" size="small" onClick={()=>{
        notification.close(key)
        this.onCloseNotification()
      }}>Accept</Button>
    )
    // TODO: link to Privacy Policy
    const description = `The ${About.name} website uses cookies to make your experience easier and better. By using this website, you consent to our use of cookies. For more information, see our Privacy Policy.`

    notification.config({placement:'bottomRight'}) // other placement options: topRight, bottomRight, bottomLeft, topLeft

    notification.open({
      message: '',
      description,
      duration: 0, // never close automatically
      style,
      btn,
      key,
    })
  }
  choose=slug=>{
    this.setState((prevState,props)=>{
      delete prevState.slug
      return prevState
    },()=>{
      if (typeof(slug)==='string'&&slug.length>0) {
        this.setState({slug})
      }
    })
  }
  renderBreadcrumb() {
    return (
      <Switch>
        <Route path="/:slug" component={BreadcrumbEntry} />
        <Route path="/" component={BreadcrumbEntry} />
      </Switch>
    )
  }
  renderLogo() {
    const {name} = About
    return (
      <div className="logo-container">
        <div className="logo" />
        <span className="logo-name">{name}</span>
      </div>
    )
  }
  renderHeader() {
    const {navs} = data
    return (
      <Layout.Header className="layout-header">
        {this.renderLogo()}
        <Menu
          theme="dark"
          mode="horizontal"
          defaultSelectedKeys={['home']}
          style={{lineHeight:'64px'}}
          >
          {
            navs.map((e,i)=>{
              const {list} = e
              if (Array.isArray(list)&&list.length>0) {
                const title = (()=>{
                  if (typeof(e.slug)==='string') {
                    return (
                      <span className="submenu-title-wrapper"><Link to={e.slug}><Icon type={e.icon} />{e.name}</Link></span>
                    )
                  }
                  return (
                    <span className="submenu-title-wrapper"><Icon type={e.icon} />{e.name}</span>
                  )
                })()
                return (
                  <Menu.SubMenu key={i} title={title}>
                    {
                      list.map((c,j)=>(
                        <Menu.Item key={j}>
                          <Link to={c.slug}>{c.name}</Link>
                        </Menu.Item>
                      ))
                    }
                  </Menu.SubMenu>
                )
              }
              const {slug} = e
              const key = typeof(slug)==='string'&&slug.length>0?slug:'home'
              return (
                <Menu.Item key={key} onClick={()=>this.choose(e.slug)}>
                  <Link to={e.slug}><Nav {...e} /></Link>
                </Menu.Item>
              )
            })
          }
        </Menu>
      </Layout.Header>
    )
  }
  renderContent() {
    return (
      <Switch>
        <Route path="/random" component={Random} />
        <Route path="/about" component={AboutPage} />
        <Route path="/privacy" component={Privacy} />
        <Route path="/terms" component={Terms} />
        <Route path="/:slug" component={Home} />
        <Route path="/" component={Home} />
      </Switch>
    )
  }
  renderAds() {
    const {adSense} = data
    return (
      <AdSense.Google
        {...adSense}
        style={{ display: 'block' }}
        format='auto'
        responsive='true'
      />
    )
  }
  render() {
    return (
      <Router>
        <Layout>
          {this.renderHeader()}
          <Layout.Content className="main-container">
            {this.renderBreadcrumb()}
            {/*this.renderAds()*/}
            {this.renderContent()}
          </Layout.Content>
          <Layout.Footer className="text-center">
            {About.name} &copy; {(new Date()).getFullYear()} {About.by.name}
          </Layout.Footer>
        </Layout>
      </Router>
    )
  }
}
